import React from 'react';
import { Translate } from 'react-redux-i18n';
import get from 'lodash.get';
import { ViewTable } from '../layouts/viewTable';
import { ViewSectionRow } from '../layouts/viewSectionRow';
import { AddressDisplay } from '../common/AddressDisplay';

interface Props { entity: any; isShowEmptyFields: boolean; translationBase: string; }
export const PageEntityManagerInformation: React.FC<Props> = ({ entity, isShowEmptyFields, translationBase }) => {
  const managerFirstName = get(entity,'manager.firstName');
  const managerLastName = get(entity,'manager.lastName');
  const managerEmail = get(entity,'manager.email');
  const managerPhone = get(entity,'phoneNumber') || get(entity,'manager.phoneNumber');
  const address = get(entity,'address');
  const managerAccountId = get(entity,'manager.id');
  const isAddressEmpty = !address || (!address.street && !address.city && !address.state && !address.postCode && !address.country);
  if (!managerAccountId && isAddressEmpty && !isShowEmptyFields) return null;
  return (
    <div className="page-entity-manager-information">
      <ViewTable title={<Translate value={`${translationBase}.manager-information.title`} />}>
        <ViewSectionRow title={`${translationBase}.manager-information.first-name`} data={managerFirstName} isShowEmptyFields={isShowEmptyFields} />
        <ViewSectionRow title={`${translationBase}.manager-information.last-name`} data={managerLastName} isShowEmptyFields={isShowEmptyFields} />
        <ViewSectionRow title={`${translationBase}.manager-information.email`} data={managerEmail} isShowEmptyFields={isShowEmptyFields} />
        <ViewSectionRow title={`${translationBase}.manager-information.phone`} data={managerPhone} isShowEmptyFields={isShowEmptyFields} />
        {!isAddressEmpty && <ViewSectionRow title={`${translationBase}.manager-information.address`} data={<AddressDisplay address={address} />} isShowEmptyFields={isShowEmptyFields} />}
      </ViewTable>
    </div>
  );
};
export default PageEntityManagerInformation;
